export default function PHP_ftp_mkdir() {
  return (
    <div>
      <h1>PHP_ftp_mkdir</h1>
    </div>
  );
}
